module.exports = __webpack_public_path__ + "static/img/1975.7ac91fd7.jpg";